import { SPEED_PRESETS } from "../sim/clock";

const logs = SPEED_PRESETS.map((p) => Math.log(p.secondsPerSecond));
const last = SPEED_PRESETS.length - 1;

export function speedFromSlider(t: number): number {
  if (t <= 0) return SPEED_PRESETS[0].secondsPerSecond;
  if (t >= 1) return SPEED_PRESETS[last].secondsPerSecond;
  const x = t * last;
  const k = Math.min(Math.floor(x), last - 1);
  const f = x - k;
  return Math.exp(logs[k] + (logs[k + 1] - logs[k]) * f);
}

export function sliderFromSpeed(speed: number): number {
  const l = Math.log(
    Math.min(
      Math.max(speed, SPEED_PRESETS[0].secondsPerSecond),
      SPEED_PRESETS[last].secondsPerSecond,
    ),
  );
  for (let k = 0; k < last; k++) {
    if (l <= logs[k + 1]) return (k + (l - logs[k]) / (logs[k + 1] - logs[k])) / last;
  }
  return 1;
}
